import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { StyledIcon } from "../../../components/StyledIcon/StyledIcon";
import { CustomButtonVariant } from "../../../components/CustomButton/CustomButton";
import DetailsModal from "../../../components/ModalDetailsGeneric/ModalDetailsGeneric";
import { BalanceContractDTO } from "../../../modules/supply/models/ContractDTO";
import { buildQuoteBalanceDetailItems } from "../utils/buildQuoteBalanceDetailItems";

interface ActionButtonsBalanceTableProps {
  row: BalanceContractDTO;
}

const ActionButtonsBalanceTable: React.FC<ActionButtonsBalanceTableProps> = ({
  row,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton onClick={handleOpen}>
        <StyledIcon iconType="info" />
      </IconButton>

      <DetailsModal
        open={open}
        onClose={handleClose}
        title="Detalhes do Saldo de Cota"
        header={{
          title: `${row.customerCompany.description} - ${row.product}`,
        }}
        data={buildQuoteBalanceDetailItems(row)}
        actions={[
          {
            label: "Fechar",
            variant: CustomButtonVariant.CONTAINED,
            onClick: handleClose,
          },
        ]}
      />
    </>
  );
};

export default ActionButtonsBalanceTable;
